export const IMAGERY_SLOW_ZOOM_FACTOR = 0.5;
